module.exports = __webpack_public_path__ + "img/jeremias.46784151.jpg";